export default __webpack_public_path__ + "static/img-blockbeats-53b400df6386fcdf3343c65ea4d45478.png";